// --- Restauración de scroll: helpers y arranque temprano ---
// El velo que evita ver la colección arriba lo pone un script inline en el <head>
// (theme.liquid). Aquí, en cuanto el script se evalúa (defer: tras el parseo, ANTES
// de DOMContentLoaded y del resto de scripts diferidos que corren después), se
// inyecta la parrilla guardada, se posiciona el scroll y se quita el velo — todo
// síncrono, sin pintados intermedios. Esperar a DOMContentLoaded dejaba la pantalla
// en blanco mientras corrían los demás scripts del tema.
const ISC_STATE_KEY = "silbon:infinite-scroll:state";
const ISC_STATE_TTL_MS = 30 * 60 * 1000;

function iscStateKeyForLocation() {
  return location.pathname + location.search;
}

function iscIsBackForwardNav() {
  const nav = performance.getEntriesByType?.("navigation")?.[0];
  if (nav) return nav.type === "back_forward";
  return performance.navigation?.type === 2;
}

function iscFindContainer() {
  return (
    document.querySelector("#product-grid product-list") ||
    document.querySelector("product-list") ||
    document.querySelector("#product-grid .product-list") ||
    document.querySelector(".product-list")
  );
}

// Scroll inmediato saltándose cualquier scroll-behavior:smooth del tema
function iscInstantScrollTo(y) {
  const html = document.documentElement;
  const prev = html.style.scrollBehavior;
  html.style.scrollBehavior = "auto";
  window.scrollTo(0, y);
  html.style.scrollBehavior = prev;
}

function iscRevealPage() {
  document.documentElement.classList.remove("isc-restoring");
  document.getElementById("isc-restoring-style")?.remove();
}

let iscEarlyRestoredPage = 0; // >0 si la restauración temprana ya inyectó la parrilla

(function iscEarlyRestore() {
  let state = null;
  try {
    const raw = sessionStorage.getItem(ISC_STATE_KEY);
    if (raw) state = JSON.parse(raw);
  } catch {
    iscRevealPage();
    return;
  }
  if (!state || !state.html || state.key !== iscStateKeyForLocation()) {
    iscRevealPage();
    return;
  }
  if (Date.now() - (state.ts || 0) > ISC_STATE_TTL_MS) {
    try {
      sessionStorage.removeItem(ISC_STATE_KEY);
    } catch {}
    iscRevealPage();
    return;
  }
  // Solo restauramos al volver atrás/adelante; una visita normal empieza arriba
  if (!iscIsBackForwardNav()) {
    iscRevealPage();
    return;
  }

  const container = iscFindContainer();
  // Sin contenedor aún no revelamos: lo reintenta el arranque normal y el velo tiene failsafe
  if (!container) return;

  try {
    history.scrollRestoration = "manual";
  } catch {}

  container.innerHTML = state.html;
  container.dataset.page = String(state.page || 1);

  // Posición objetivo: el ancla guardada si sigue existiendo; si no, el scrollY crudo
  const anchorEl = state.anchorId
    ? container.querySelector(`.product-card[data-product-id="${state.anchorId}"]`)
    : null;
  const targetY = () => {
    if (anchorEl && anchorEl.isConnected) {
      const y = anchorEl.getBoundingClientRect().top + (window.scrollY || 0) - (state.anchorOffset || 0);
      return Math.max(0, y);
    }
    return state.scrollY || 0;
  };

  iscInstantScrollTo(targetY());
  iscRevealPage();

  // Mientras el layout se asienta (lazy images, scripts del tema), re-fijamos la
  // posición contra el ancla. Si el usuario interactúa, paramos: su scroll manda.
  let cancelled = false;
  const cancel = () => (cancelled = true);
  ["wheel", "touchstart", "keydown", "pointerdown"].forEach((ev) =>
    window.addEventListener(ev, cancel, { once: true, passive: true })
  );
  let elapsed = 0;
  const relock = setInterval(() => {
    elapsed += 100;
    if (cancelled || elapsed >= 1500) {
      clearInterval(relock);
      try {
        history.scrollRestoration = "auto";
      } catch {}
      return;
    }
    const t = targetY();
    if (Math.abs((window.scrollY || 0) - t) > 2) iscInstantScrollTo(t);
  }, 100);

  iscEarlyRestoredPage = state.page || 1;
})();

document.addEventListener("DOMContentLoaded", function () {
  let isFetching = false;
  let observer = null;
  let productContainer = null;
  let sentinel = null;
  let watchdog = null;
  let scrollListenerAttached = false;
  const SCROLL_THRESHOLD_PCT = 15;
  const SCROLL_DEBOUNCE_MS = 50;
  const SCROLL_DELTA = 50;
  let lastScrollY = 0;
  let debounceTO = null;
  let restoreAttempted = false;

  // --- Hook de history: dispara 'locationchange' en push/replaceState y popstate
  (function () {
    const _push = history.pushState;
    const _replace = history.replaceState;
    history.pushState = function () {
      const r = _push.apply(this, arguments);
      window.dispatchEvent(new Event("locationchange"));
      return r;
    };
    history.replaceState = function () {
      const r = _replace.apply(this, arguments);
      window.dispatchEvent(new Event("locationchange"));
      return r;
    };
    window.addEventListener("popstate", () => {
      window.dispatchEvent(new Event("locationchange"));
    });
  })();

  const getContainer = () =>
    document.querySelector("#product-grid product-list") ||
    document.querySelector("product-list") ||
    document.querySelector("#product-grid .product-list") ||
    document.querySelector(".product-list");

  function ensureSentinel() {
    if (!productContainer) return;
    if (!sentinel || !sentinel.isConnected) {
      sentinel = document.createElement("div");
      sentinel.id = "infinite-sentinel";
      sentinel.setAttribute("aria-hidden", "true");
      sentinel.style.cssText = "display:block;width:100%;height:1px;margin-top:1px;";
      productContainer.appendChild(sentinel);
    }
  }

  // Re-activa nodos insertados como HTML inerte: ejecuta sus <script>, re-inicia
  // el slider global y despierta las imágenes lazy (mismo camino que en cargas nuevas)
  function activateNodes(nodes) {
    nodes.forEach((root) => {
      root.querySelectorAll("script").forEach((old) => {
        const s = document.createElement("script");
        for (const attr of old.attributes) s.setAttribute(attr.name, attr.value);
        s.textContent = old.textContent;
        old.replaceWith(s);
      });
    });

    if (typeof window.initSwipeSlider === "function") {
      window.initSwipeSlider();
    }

    if (window.lazySizes?.loader) {
      nodes.forEach((node) => {
        node.querySelectorAll("img.lazyload, source[data-srcset]").forEach((el) => {
          window.lazySizes.loader.unveil(el);
        });
      });
    } else {
      nodes.forEach((node) => {
        node.querySelectorAll("img[data-src]").forEach((img) => (img.src = img.dataset.src));
        node.querySelectorAll("source[data-srcset]").forEach((src) => (src.srcset = src.dataset.srcset));
      });
    }
  }

  // --- Guardado de estado al salir hacia una ficha de producto ---
  function saveScrollState() {
    if (!productContainer || !productContainer.isConnected) return;
    try {
      // Ancla: la primera tarjeta visible en el viewport. Restaurar contra un
      // elemento aguanta los saltos de layout (lazy images) mejor que un scrollY fijo.
      let anchorId = "";
      let anchorOffset = 0;
      for (const card of productContainer.querySelectorAll(".product-card[data-product-id]")) {
        const rect = card.getBoundingClientRect();
        if (rect.bottom > 0) {
          anchorId = card.getAttribute("data-product-id");
          anchorOffset = rect.top;
          break;
        }
      }

      // Guardamos la parrilla sin el sentinel para no serializar ids duplicados
      const clone = productContainer.cloneNode(true);
      clone.querySelector("#infinite-sentinel")?.remove();
      sessionStorage.setItem(
        ISC_STATE_KEY,
        JSON.stringify({
          key: iscStateKeyForLocation(),
          html: clone.innerHTML,
          page: getCurrentPage(),
          scrollY: window.scrollY || document.documentElement.scrollTop || 0,
          anchorId,
          anchorOffset,
          ts: Date.now(),
        })
      );
    } catch {
      // Cuota llena o modo privado: sin estado guardado, comportamiento de siempre
    }
  }

  function tryRestoreScrollState() {
    if (restoreAttempted || !productContainer) return;

    // Caso normal: la restauración temprana ya inyectó parrilla y posicionó el scroll.
    // Aquí solo queda hidratar (scripts embebidos, slider, lazy), que a la hora del
    // eval temprano aún no estaban cargados.
    if (iscEarlyRestoredPage > 0) {
      restoreAttempted = true;
      activateNodes(Array.from(productContainer.children).filter((n) => n.id !== "infinite-sentinel"));
      return;
    }

    restoreAttempted = true;

    // Fallback (el contenedor no existía al evaluar el script): misma restauración, tardía
    let state = null;
    try {
      const raw = sessionStorage.getItem(ISC_STATE_KEY);
      if (raw) state = JSON.parse(raw);
    } catch {
      iscRevealPage();
      return;
    }
    if (!state || !state.html || state.key !== iscStateKeyForLocation()) {
      iscRevealPage();
      return;
    }
    if (Date.now() - (state.ts || 0) > ISC_STATE_TTL_MS) {
      try {
        sessionStorage.removeItem(ISC_STATE_KEY);
      } catch {}
      iscRevealPage();
      return;
    }
    if (!iscIsBackForwardNav()) {
      iscRevealPage();
      return;
    }

    try {
      history.scrollRestoration = "manual";
    } catch {}

    productContainer.innerHTML = state.html;
    sentinel = null;
    ensureSentinel();
    setCurrentPage(state.page || 1);
    activateNodes(Array.from(productContainer.children));

    const anchorEl = state.anchorId
      ? productContainer.querySelector(`.product-card[data-product-id="${state.anchorId}"]`)
      : null;
    const targetY = () => {
      if (anchorEl && anchorEl.isConnected) {
        const y = anchorEl.getBoundingClientRect().top + (window.scrollY || 0) - (state.anchorOffset || 0);
        return Math.max(0, y);
      }
      return state.scrollY || 0;
    };

    iscInstantScrollTo(targetY());
    iscRevealPage();

    let cancelled = false;
    const cancel = () => (cancelled = true);
    ["wheel", "touchstart", "keydown", "pointerdown"].forEach((ev) =>
      window.addEventListener(ev, cancel, { once: true, passive: true })
    );
    let elapsed = 0;
    const relock = setInterval(() => {
      elapsed += 100;
      if (cancelled || elapsed >= 1500) {
        clearInterval(relock);
        try {
          history.scrollRestoration = "auto";
        } catch {}
        return;
      }
      const t = targetY();
      if (Math.abs((window.scrollY || 0) - t) > 2) iscInstantScrollTo(t);
    }, 100);
  }

  function getCurrentPage() {
    return parseInt(productContainer?.dataset.page || "1", 10);
  }
  function setCurrentPage(page) {
    if (productContainer) productContainer.dataset.page = String(page);
  }

  function removeScrollListener() {
    if (scrollListenerAttached) {
      window.removeEventListener("scroll", onWindowScroll, { passive: true });
      scrollListenerAttached = false;
    }
  }
  function addScrollListener() {
    if (!scrollListenerAttached) {
      window.addEventListener("scroll", onWindowScroll, { passive: true });
      scrollListenerAttached = true;
    }
  }
  function onWindowScroll() {
    if (isFetching) return;
    const y = window.scrollY || document.documentElement.scrollTop || 0;
    if (Math.abs(y - lastScrollY) < SCROLL_DELTA) return;
    lastScrollY = y;
    if (debounceTO) clearTimeout(debounceTO);
    debounceTO = setTimeout(() => {
      const h = window.innerHeight;
      const docH = document.documentElement.scrollHeight;
      const pct = ((y + h) / docH) * 100;
      if (pct >= SCROLL_THRESHOLD_PCT) loadMoreProducts();
    }, SCROLL_DEBOUNCE_MS);
  }

  function initObserver() {
    if (!productContainer) return;
    ensureSentinel();

    if (observer) observer.disconnect();

    // CLAVE: usa viewport siempre para evitar roots falsos por barras sticky/overflow
    try {
      observer = new IntersectionObserver(
        (entries) => {
          if (entries[0]?.isIntersecting) loadMoreProducts();
        },
        { root: null, rootMargin: "1000px 0px", threshold: 0 }
      );
      observer.observe(sentinel);
    } catch {
      observer = null;
    }

    // Fallback por si IO no existe o el sentinel no intersecta por cualquier motivo
    addScrollListener();
  }

  function boot() {
    const c = getContainer();
    if (!c) return false;

    // Si cambió el nodo, resetea
    if (productContainer !== c) {
      productContainer = c;
      if (observer) observer.disconnect();
      observer = null;
      sentinel = null;
      removeScrollListener();
    }

    if (!productContainer.dataset.page) setCurrentPage(1);
    tryRestoreScrollState();
    ensureSentinel();
    initObserver();

    // autoload si la página queda corta
    if (document.documentElement.scrollHeight <= window.innerHeight * 1.2) {
      loadMoreProducts();
    }
    return true;
  }

  // Arranque inicial + watchdog
  const started = boot();
  if (!started) {
    const bootMo = new MutationObserver(() => {
      if (boot()) bootMo.disconnect();
    });
    bootMo.observe(document.body, { childList: true, subtree: true });
  }

  // Watchdog: valida cada 500ms que todo siga enganchado (por si el tema re-renderiza sin avisar)
  function startWatchdog() {
    if (watchdog) clearInterval(watchdog);
    watchdog = setInterval(() => {
      const exists = !!getContainer();
      if (!exists || !productContainer?.isConnected) {
        boot();
        return;
      }
      if (!sentinel || !sentinel.isConnected) {
        ensureSentinel();
        initObserver();
      }
    }, 500);
  }
  startWatchdog();

  // Al salir de la página (ir a una ficha, cerrar…) guardamos la parrilla y el scroll.
  // Si el navegador restaura por bfcache no hace falta nada: el DOM vuelve intacto.
  window.addEventListener("pagehide", saveScrollState);

  // Rebind explícito según cambian filtros o la URL
  window.addEventListener("locationchange", () => {
    setTimeout(() => boot(), 50);
  });
  document.addEventListener("facet:update", () => {
    setTimeout(() => {
      const newContainer = getContainer();
      if (!newContainer) return;
      if (productContainer !== newContainer) {
        productContainer = newContainer;
      }
      setCurrentPage(1);
      ensureSentinel();
      initObserver();
      if (typeof window.initSwipeSlider === "function") window.initSwipeSlider();
    }, 300);
  });

  function loadMoreProducts() {
    if (isFetching || !productContainer) return;
    isFetching = true;

    const nextPage = getCurrentPage() + 1;
    const url = new URL(window.location.href);
    url.searchParams.set("page", nextPage);

    fetch(url.href, {
      headers: { "X-Requested-With": "XMLHttpRequest", Accept: "text/html" },
      cache: "no-store",
    })
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");

        // MISMO selector que en prod para evitar sorpresas
        const newProducts = doc.querySelectorAll("product-list .product-card");

        // Si no hay más productos —> apagamos IO y scroll
        if (!newProducts.length) {
          if (observer) observer.disconnect();
          removeScrollListener();
          isFetching = false;
          return;
        }

        const frag = document.createDocumentFragment();
        let added = 0;

        newProducts.forEach((card) => {
          // Usamos data-product-id (product.id, siempre único) para dedup, no data-id (SKU puede estar vacío o repetido)
          const pid = card.getAttribute("data-product-id") || card.getAttribute("data-id");
          const attr = card.getAttribute("data-product-id") ? "data-product-id" : "data-id";
          if (!pid || !productContainer.querySelector(`[${attr}="${pid}"]`)) {
            frag.appendChild(card);
            added++;
          }
        });

        if (added > 0) {
          requestAnimationFrame(() => {
            ensureSentinel();

            const newNodes = Array.from(frag.children);
            // Inserta antes del sentinel para mantener el sentinel siempre al final
            productContainer.insertBefore(frag, sentinel);

            // Ejecuta <script> embebidos, re-init del slider y lazy — mismo camino que al restaurar
            activateNodes(newNodes);

            // Señales suaves
            window.dispatchEvent(new Event("resize"));
            window.dispatchEvent(new Event("scroll"));

            // Estado
            setCurrentPage(nextPage);

            // Re-observar por si el sentinel se movió
            initObserver();

            document.dispatchEvent(
              new CustomEvent("productsLoaded", { detail: { count: added, page: nextPage } })
            );
          });
        } else {
          // No añadimos nada — avanzamos página por si acaso y paramos
          setCurrentPage(nextPage);
          if (observer) observer.disconnect();
          removeScrollListener();
        }
      })
      .catch((e) => console.error("InfiniteScroll fetch error:", e))
      .finally(() => {
        isFetching = false;
      });
  }

  // Fallback por mutaciones gordas en el grid
  const mo = new MutationObserver((muts) => {
    for (const m of muts) {
      if (m.type === "childList") {
        const touched =
          [...m.addedNodes, ...m.removedNodes].some(
            (n) =>
              n.nodeType === 1 &&
              (n.matches?.("product-list,.product-list") || n.querySelector?.("product-list,.product-list"))
          );
        if (touched) {
          setTimeout(boot, 30);
          break;
        }
      }
    }
  });
  mo.observe(document.body, { childList: true, subtree: true });
});
